import React, { Fragment, useCallback, useContext, useState, useEffect } from "react";
import axios from "axios";
import { Breadcrumbs } from "../../AbstractElements";
import { Container, Row, Col } from "reactstrap";
// import ExerciseContext from "../../_helper/ExerciseContext";
// import ExerciseCategory from "./comp/ExerciseCategory";
import AllExercisesTable from "./comp/AllDealsTable";

const ViewExercises = () => {
  // const { exercises } = useContext(ExerciseContext);
  const initialIndex = { index: 0, isOpen: false };
  const [exerciseIndex, setExerciseIndex] = useState(initialIndex);
  const [exercises, setExercises] = useState([]);

  const fetchExercises = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDaily`);
      setExercises(response.data.dailyWorkOut);
    } catch (error) {
      console.error("Error fetching exercises:", error);
    }
  };

  useEffect(() => {
    fetchExercises();
  }, []);

  const callback = useCallback((exercise) => {
    setExerciseIndex(exercise);
  }, []);

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Exercises" parent="Exercises" title="All Exercises" />

      <Container fluid={true}>
      
        <Row>
          <Col sm="12">
            <AllExercisesTable
              exercises={exercises}
              setExerciseIndex={callback}
              exerciseIndex={exerciseIndex}
            />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ViewExercises;

// import React, { Fragment, useCallback, useContext, useState } from "react";
// import { Breadcrumbs } from "../../AbstractElements";
// import { Container, Row, Col } from "reactstrap";
// // import ExerciseContext from "../../_helper/ExerciseContext";
// // import ExerciseCategory from "./comp/ExerciseCategory";
// import AllExercisesTable from "./comp/AllDealsTable";

// const ViewExercises = () => {
//   // const { exercises } = useContext(ExerciseContext);
//   const initialIndex = { index: 0, isOpen: false };
//   const [exerciseIndex, setExerciseIndex] = useState(initialIndex);

//   const callback = useCallback((exercise) => {
//     setExerciseIndex(exercise);
//   });
//   const [exercises, setExercises] = useState([
//     { id: 1, category: "Daily Workout", name: "Push Ups", duration: "10 min" },
//     { id: 2, category: "Single Exercise", name: "Squats", duration: "5 min" },
//     { id: 3, category: "Fitness Challenge", name: "Plank", duration: "3 min" },
//     { id: 4, category: "Daily Workout", name: "Lunges", duration: "10 min" },
//   ]);
//   return (
//     <Fragment>
//       <Breadcrumbs mainTitle="Exercises" parent="Exercises" title="All Exercises" />

//       <Container fluid={true}>
//         <Row>
//           <Col sm="12">
//             {/* <ExerciseCategory exercises={exercises} /> */}
//           </Col>
//         </Row>
//         <Row>
//           <Col sm="12">
//             <AllExercisesTable
//               exercises={exercises}
//               setExerciseIndex={callback}
//               exerciseIndex={exerciseIndex}
//             />
//           </Col>
//         </Row>
//       </Container>
//     </Fragment>
//   );
// };

// export default ViewExercises;

// // import React, { Fragment, useCallback, useContext, useState } from "react";
// // import { Breadcrumbs } from "../../AbstractElements";
// // import ListOfImageDesc from "./comp/ListOfImgDesc";
// // import { Container, Row } from "reactstrap";
// // import GalleryContext from "../../_helper/Gallery";
// // import DealCategory from "./comp/DealCategory";
// // import iii from "../../../src/assets/cashflowimg/apartments/a1.png"
// // import AllDealsTable from "./comp/AllDealsTable";
// // const ViewDeals = () => {
// //   const { images, smallImages } = useContext(GalleryContext);
// //   const initilindex = { index: 0, isOpen: false };
// //   const [photoIndex, setPhotoIndex] = useState(initilindex);

// //   const callback = useCallback((photo) => {
// //     setPhotoIndex(photo);
// //   });

// //   return (
// //     <Fragment>
// //       <Breadcrumbs mainTitle="Deals" parent="Deals" title="All Deals" />

// //       {/* <Container fluid={true}> */}
// //         {/* <Row> */}
// //           {/* <DealCategory smallImages={featureProduct} /> */}
// //           {/* <ListOfImageDesc
// //             smallImages={featureProduct}
// //             setPhotoIndex={callback}
// //             photoIndex={photoIndex}
// //             withDesc={true}
// //           /> */}
// //           <AllDealsTable/>
// //         {/* </Row>
// //       </Container> */}
// //     </Fragment>
// //   );
// // };

// // export default ViewDeals;

